import axios from 'axios'
import config from './config';
import base from './base'

//配置
axios.default.timeout = 60000;  //设置全局时间
axios.defaults.withCredentials = false;

// 正在进行中的请求列表
let reqList = [];

/**
 * 阻止重复请求
 * @param {array} reqList - 请求缓存列表
 * @param {string} url - 当前请求地址
 * @param {function} cancel - 请求中断函数
 * @param {string} errorMessage - 请求中断时需要显示的错误信息
 */
const stopRepeatRequest = function (reqList, url, cancel, errorMessage, http_timeout = config.httpTimeout) {
    const errorMsg = errorMessage || '';
    var tmp = true;
    for (let i = 0; i < reqList.length; i++) {
        if (reqList[i] === url) {
            tmp = false;
            cancel(errorMsg);
            return
        }
    }
    if (tmp) {
        reqList.push(url);
        setTimeout(() => {
            cancel("http_timeout");
            allowRequest(reqList, url);
        }, http_timeout);
    }
};

/**
 * 允许某个请求可以继续进行
 * @param {array} reqList 全部请求列表
 * @param {string} url 请求地址
 */
const allowRequest = function (reqList, url) {
    for (let i = 0; i < reqList.length; i++) {
        if (reqList[i] === url) {
            reqList.splice(i, 1);
            break
        }
    }
};

// 请求拦截器
axios.interceptors.request.use(
    config => {
        // 设置cancelToken对象
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        config.cancelToken = source.token;
        // 阻止重复请求。当上个请求未完成时，相同的请求不会进行
        // stopRepeatRequest(reqList, config.url, source.cancel, 'repeated_requests', config.http_timeout);
        return config
    },
    err => Promise.reject(err)
);

// 响应拦截器
axios.interceptors.response.use(
    response => {
        allowRequest(reqList, response.config.url);
        // ...请求成功后的后续操作
        return Promise.resolve(response);
    },
    error => {
        if (error.message === "repeated_requests") {
            // console.log('请求被终断');
            return Promise.reject("repeated_requests");
        }
        else if (error.message === 'http_timeout') {
            // console.log('请求超时');
            return Promise.reject("http_timeout");
        }
        else {
            allowRequest(reqList, error.config.url);
            return Promise.reject(error);
        }
    }
);

function request (url, method, data, callback) {
    var self = this;
    if (url.setUrl) {
        url = url.setUrl;
    }
    else {
        url = config.baseApi + url;
    }
    //base.setSign(data);//签名

    var timeout = config.httpTimeout;
    if (data.http_timeout) {
        timeout = data.http_timeout;
    }

    return axios({
        http_timeout: timeout,
        search_time: data.search_time,
        url: url,
        method: method,
        data: data,//btoa(),//btoa base64
        headers: {
            'content-type': 'application/json',
            'access-token': base.getToken(),
            'last-org-id': base.getOrgId(),
            'last-role-id': base.getRoleId(),
            'Accept-Language': base.getLang(),
        }
    }).then(function (res) {
        if (typeof res.data == 'string') {
            const resStr = res.data
            res.data = JSON.parse(resStr.substring(resStr.indexOf('{"s":'), resStr.length));
        }

        success(res, callback, url, method, data);
        return res;
    }).catch(err => {
        error(err, callback);
        return err;
    });
}
//成功回调
function success (res, callback, url, method, params) {
    if (typeof (callback) == "function") {
        res = res.data;
        var lang = config.i18n._vm.messages[base.getLang()];

        var errno, errmsg, data;
        errno = res.s; errmsg = res.m; data = res.d;
        // console.log(errno)
        if (errno == "401") {
            base.logout();
            base.hideLoading();
            return;
        }
        else if (errno == "403") {
            base.hideLoading();
            base.msgWarning(lang.no_role)
            return;
        }
        // console.log(url, '\n', '============>>>\n', `${method} params:`, params, '\n', data)
        var error = {
            errno: errno,
            errmsg: errmsg
        };
        return callback(errno == 0, data, error);
    }
}
//失败回调
function error (res, callback) {
    // console.log(res.response);
    // var status = res.response?res.response.status:"";
    var lang = config.i18n._vm.messages[base.getLang()];

    if (typeof (callback) == "function") {

        var resmsg = res.toString();
        if (resmsg === "repeated_requests") {
            console.log("重复请求被终断");
        }
        else {
            var errmsg = resmsg == "http_timeout" ? lang.http_overtime : lang.server_error;
            var error = {
                errno: "-1",
                errmsg: errmsg
            };
            return callback(false, null, error);
        }
    }
}
//发送get
export function sendGet (url, data, callback) {
    return request(url, "get", data, callback);
}
//发送post
export function sendPost (url, data, callback) {
    return request(url, "post", data, callback);
}

//发送post img
export function sendPostImg (url, data, callback) {
    let headers = {
        headers: {
            "Content-Type": "multipart/form-data",
            'access-token': base.getToken(),
            'last-org-id': base.getOrgId(),
            'last-role-id': base.getRoleId(),
            'Accept-Language': base.getLang(),
        }
    };
    axios.post(config.baseApi + url, data, headers).then(function (res) {
        success(res, callback);
    }).catch(err => {
        error(err, callback);
    });
}
export default {
    sendGet,
    sendPost,
    sendPostImg
}



// WEBPACK FOOTER //
// ./src/utils/request.js